/**
 * ReferralTracker - Captures referral codes from URL params on every page load.
 *
 * Renders nothing. Simply calls useReferralTracking() so that
 * `?ref=CODE` or `?partner=CODE` query params are captured into a 30-day cookie
 * for later attribution during signup.
 *
 * Mounted once inside the root Providers component.
 */

import { useReferralTracking } from '@/hooks/useReferralTracking';

export function ReferralTracker() {
  useReferralTracking();
  return null;
}
